import { useEffect, useState } from 'react';
import { useMembershipQuery } from '../../generated/graphql';
import { withCurrentQueryParams } from '../../helpers/withCurrentQueryParams';
import flipperClient from '../../services/flipper-api/flipper-api.service';

const EXPERIMENT_ID = process.env.REACT_APP_FLIPPER_CUSTOM_MESSAGING_EXP_ID;
const VARIANT_ID = process.env.REACT_APP_FLIPPER_CUSTOM_MESSAGING_VARIANT_ID;
export const CUSTOM_MESSAGING_ROUTE = '/our-guest-list/messages';
// Cap how long control/unbucketed users wait on flipper before the hub renders anyway.
export const ASSIGNMENT_TIMEOUT_MS = 1500;

/**
 * Workaround for the top nav not being able to read flipper: sends users already bucketed
 * into the "Guest List: Custom Messaging" variant to the new messaging app.
 * Uses the read-only assignment lookup so unbucketed users are never bucketed here.
 */
export const useCustomMessagingRedirect = () => {
  const isEnabled = !!EXPERIMENT_ID && !!VARIANT_ID;
  const [isChecking, setIsChecking] = useState(isEnabled);
  const { data: memberData, loading: memberLoading } = useMembershipQuery({ skip: !isEnabled });
  const memberId = memberData?.member?.id;

  useEffect(() => {
    if (!isEnabled || memberLoading) return;
    if (!memberId) {
      setIsChecking(false);
      return;
    }

    let isCancelled = false;
    const timeout = new Promise<undefined>(resolve => setTimeout(() => resolve(undefined), ASSIGNMENT_TIMEOUT_MS));

    Promise.race([
      flipperClient
        .getAssignmentReadOnly({ experimentId: EXPERIMENT_ID as string, bucketingId: memberId })
        .then((result: any) => result?.data?.variant_id as string | undefined)
        .catch(() => undefined),
      timeout,
    ]).then(variantId => {
      if (isCancelled) return;
      if (variantId === VARIANT_ID) {
        window.location.replace(withCurrentQueryParams(CUSTOM_MESSAGING_ROUTE));
        return;
      }
      setIsChecking(false);
    });

    return () => {
      isCancelled = true;
    };
  }, [isEnabled, memberId, memberLoading]);

  return { isChecking };
};
